/** index.hooks */
/** 基础hooks */
const useHooks = () => {
  /** 分页options */
  const getPageOption = ['10', '20', '30', '40', '50'];
  return { getPageOption };
};
export default useHooks;
